var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        staticClass: "confirm-mask",
      },
      [
        _c("div", { staticClass: "confirm-container relative" }, [
          _c("i", {
            staticClass: "el-icon-close absolute pointer",
            staticStyle: {
              right: "16px",
              top: "16px",
              "font-size": "20px",
              color: "#666666",
            },
            on: { click: _vm.close },
          }),
          _c("p", { staticClass: "title" }, [
            _vm._v("大模型根据您的指令生成报告"),
          ]),
          _c("div", { staticClass: "disassembly-view flex items-center" }, [
            _c(
              "div",
              {
                staticClass:
                  "input-content flex-column items-center justify-between",
              },
              [
                _c("div", { staticClass: "current_radio relative" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center type-radio",
                    },
                    [
                      _vm.textObj.input && _vm.textObj.file
                        ? [
                            _c(
                              "span",
                              {
                                class: { active: _vm.current === "input" },
                                on: {
                                  click: function ($event) {
                                    _vm.current = "input"
                                  },
                                },
                              },
                              [_vm._v("手动输入")]
                            ),
                            _c("i", [_vm._v("|")]),
                            _c(
                              "span",
                              {
                                class: { active: _vm.current === "file" },
                                on: {
                                  click: function ($event) {
                                    _vm.current = "file"
                                  },
                                },
                              },
                              [_vm._v("文件解析")]
                            ),
                          ]
                        : _vm._e(),
                      _vm.textObj.input && !_vm.textObj.file
                        ? [
                            _c(
                              "span",
                              {
                                class: { active: _vm.current === "input" },
                                staticStyle: { cursor: "text" },
                              },
                              [_vm._v("手动输入")]
                            ),
                          ]
                        : _vm._e(),
                      !_vm.textObj.input && _vm.textObj.file
                        ? [
                            _c(
                              "span",
                              {
                                class: { active: _vm.current === "file" },
                                staticStyle: { cursor: "text" },
                              },
                              [_vm._v("文件解析")]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
                _vm.current === "input"
                  ? _c("p", {
                      staticClass: "input-file-render scroll-container",
                      domProps: { innerHTML: _vm._s(_vm.textObj[_vm.current]) },
                    })
                  : _vm._e(),
                _vm.current === "file"
                  ? _c("p", {
                      staticClass:
                        "input-file-render markdown-body scroll-container",
                      domProps: { innerHTML: _vm._s(_vm.textObj[_vm.current]) },
                    })
                  : _vm._e(),
              ]
            ),
            _c("div", {
              staticStyle: {
                height: "100%",
                width: "0",
                background: "transparent",
                "border-left": "1px dashed rgba(0,0,0,0.1)",
              },
            }),
            _c(
              "div",
              {
                staticClass:
                  "input-content flex-column items-center justify-between",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "right-top",
                    staticStyle: { width: "100%", "flex-shrink": "0" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex items-center",
                        staticStyle: {
                          color: "#0226E0",
                          height: "18px",
                          "line-height": "18px",
                          padding: "0 14px 6px",
                        },
                      },
                      [
                        _c("img", {
                          staticStyle: { "margin-right": "5px" },
                          attrs: {
                            src: require("../../../assets/images/achievement/keywordContent.png"),
                            height: 13,
                            width: 15,
                            alt: "",
                          },
                        }),
                        _vm._v(" 基于大模型的技术需求拆解 "),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        ref: "descContent",
                        staticClass: "field-content scroll-container",
                        staticStyle: { "max-height": "255px" },
                      },
                      [_vm._v(" " + _vm._s(_vm.technology) + " ")]
                    ),
                    _c("div", { staticClass: "keyword-input" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "14px",
                            height: "14px",
                            padding: "10px 14px",
                            color: "#181F33",
                          },
                        },
                        [_vm._v("关键词：")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "keyword-box scroll-container",
                          style: { maxHeight: _vm.keywordHeight + "px" },
                        },
                        _vm._l(_vm.keywordTags, function (tag, ind) {
                          return _c(
                            "div",
                            {
                              key: ind,
                              staticClass: "tag-item",
                              staticStyle: { "padding-right": "8px" },
                            },
                            [_c("span", [_vm._v(_vm._s(tag.tagName))])]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }